<template>
  <div>
    <ContentHeader title="Detail Agent" />
    <ib-detail-skeleton v-if="loading"></ib-detail-skeleton>
    <section class="content" v-else>
      <div class="container-fluid">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div
                class="
                  col-md-4
                  d-flex
                  justify-content-center
                  align-items-center
                "
                v-if="cp.image"
              >
                <img
                  class="detail-image"
                  :src="`http://localhost:8000${cp.image}`"
                  alt="User profile picture"
                />
              </div>
              <div
                class="
                  col-md-4
                  d-flex
                  justify-content-center
                  align-items-center
                "
                v-else
              >
                <img
                  class="detail-image"
                  src="@/assets/svg/male.svg"
                  alt="User profile picture"
                />
              </div>
              <div class="col-md-8 info-detail">
                <h3 class="font-weight-bold">
                  {{
                    ibd.investor.name
                      ? ibd.investor.name
                      : "Company Name Doesn't Exist"
                  }}
                </h3>
                <h3
                  :class="
                    ibd.level == 'PARTNER_IB'
                      ? 'text-info'
                      : ibd.level == 'INTRODUCING_BROKER'
                      ? 'text-warning'
                      : ibd.level == 'MASTER_IB'
                      ? 'text-success'
                      : 'text-danger'
                  "
                >
                  <span
                    :class="
                      ibd.level == 'PARTNER_IB'
                        ? 'badge badge-info'
                        : ibd.level == 'INTRODUCING_BROKER'
                        ? 'badge badge-warning'
                        : ibd.level == 'MASTER_IB'
                        ? 'badge badge-success'
                        : 'badge badge-danger'
                    "
                  >
                    {{
                      ibd.level == "PARTNER_IB"
                        ? "Supervisor Area"
                        : ibd.level == "INTRODUCING_BROKER"
                        ? "Agent Level"
                        : ibd.level == "MASTER_IB"
                        ? "Manager Area"
                        : "EMPTY"
                    }}
                  </span>
                </h3>
                <div>
                  <h5 class="mb-0 fw-bold">Status</h5>
                  <p
                    :class="
                      ibd.is_active == true
                        ? 'text-success d-inline'
                        : 'text-danger d-inline'
                    "
                  >
                    <span
                      :class="
                        ibd.is_active == true
                          ? 'badge badge-success'
                          : 'badge badge-danger'
                      "
                    >
                      {{ ibd.is_active == true ? "ACTIVE" : "NON ACTIVE" }}
                    </span>
                  </p>
                </div>
                <p></p>
              </div>
            </div>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header">
                <div class="card-tools">
                  <div class="d-flex filter-container">
                    <select
                      class="form-select mr-3 w-25 select-perpage"
                      v-model="table.perPage"
                    >
                      <option value="5">5</option>
                      <option value="10" selected>10</option>
                      <option value="20">20</option>
                      <option value="50">50</option>
                    </select>
                    <input
                      type="text"
                      name="search"
                      class="form-control w-75 search-bar"
                      placeholder="Search"
                      v-model="table.filter"
                    />
                  </div>
                </div>
              </div>
              <div class="card-body table-responsive p-0">
                <b-table
                  hover
                  responsive
                  :items="disbursement"
                  :fields="table.fields"
                  :current-page="table.currentPage"
                  :per-page="table.perPage"
                  :filter="table.filter"
                  show-empty
                >
                  <template #empty="scope">
                    <p class="text-center">
                      {{ scope.emptyText }}
                    </p>
                  </template>
                  <template #emptyFiltered="scope">
                    <p class="text-center">
                      {{ scope.emptyFilteredText }}
                    </p>
                  </template>
                  <template #cell(No)="data">
                    {{
                      (table.currentPage - 1) * table.perPage + data.index + 1
                    }}
                  </template>
                </b-table>
              </div>
              <b-pagination
                v-model="table.currentPage"
                :total-rows="table.totalRows"
                :per-page="table.perPage"
                class="my-0 p-3"
              ></b-pagination>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import IbDetailSkeleton from "@/components/loading-screen/IbDetailSkeleton.vue";
import ContentHeader from "@/components/molecules/ContentHeader.vue";
import apiClient from "@/services/ApiServices";
import apiIB from "@/services/ApiServicesIB";

export default {
  components: {
    ContentHeader,
    IbDetailSkeleton
  },

  created() {
    document.title = "Detail IB - Manager Cabang";
  },

  data() {
    return {
      loading : true,
      ibd: {},
      cp: [],
      cp_id: 0,
      disbursement: [],
      table: {
        currentPage: 1,
        totalRows: 1,
        perPage: 10,
        filter: "",
        fields: [
          "No",
          {
            key: "transaction.transaction_code",
            label: "Transaction Code",
            sortable: true,
          },
          {
            key: "transaction.product_type",
            label: "Product Type",
            sortable: true,
          },
          {
            key: "transaction.investor.name",
            label: "Investor Name",
            sortable: true,
          },
          {
            key: "transaction.deposit_amount",
            label: "Deposit Ammount",
            sortable: false,
          },
          {
            key: "amount",
            sortable: false,
          },
          {
            key: "status",
            sortable: false,
          },
          // "Action",
        ],
      },
    };
  },

  async mounted() {
    try {
      let ibd = await apiIB.get(`${this.$route.params.id}/`);
      this.ibd = ibd.data.data;

      let cp = await apiClient.get(`${this.ibd.corporate_partner_id}/`);
      this.cp = cp.data.data;

      let response = await apiIB.get(`${this.$route.params.id}/disbursement/`)
      this.disbursement = response.data.data 
      console.log(this.disbursement)
      
      this.table.totalRows = this.disbursement.length;
    } catch (error) {
      this.$swal(
        "Oooopss....",
        error.data.data.message,
        "error"
      );
    } finally {
      this.loading = false
    }
  },
  methods: {
    onFiltered(items) {
      this.table.totalRows = items.length;
      this.table.currentPage = 1;
    },
  },
};
</script>

<style scoped>
.info-box {
  height: 100%;
  margin-bottom: 0 !important;
}
.detail-image {
  --size: 250px;
  border-radius: 100vh;
  width: var(--size);
  height: var(--size);
}

.info-detail {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

@media only screen and (max-width: 600px) {
  .card-header {
    flex-direction: column;
    align-items: center;
  }
  .add-button {
    width: 100%;
    margin-bottom: 0.75rem;
  }
  .input-search {
    width: 100% !important;
  }
}
.card-header {
  display: flex;
  justify-content: space-between;
}
.card-header::after {
  display: none !important;
  content: "";
}
.input-search {
  width: 250px;
}
</style>